import { APP_ENV } from "@Constants/env";

/**
 * The security level code.
 */
export const LOG_SEVERITY = {
  INFO: 1,
  ERROR: 2,
  WARNING: 3,
};

/**
 * Log an error message.
 */
export function logError(message) {
  logger(message, LOG_SEVERITY.ERROR);
}

/**
 * Log an info message.
 */
export function logInfo(message) {
  logger(message, LOG_SEVERITY.INFO);
}

/**
 * Log a warning message.
 */
export function logWarning(message, ...args) {
  logger(message, LOG_SEVERITY.WARNING, ...args);
}

/**
 * Logs a message to the console with a specified severity level.
 *
 * @param {String} message  The message to log.
 * @param {Number} severity The severity level of the log message.
 *
 * @remarks The logger will output the following format to the console:
 * "[2025-06-18T15:24:10]: The helpful message we want to log."
 */
export default function logger(message, severity = LOG_SEVERITY.INFO, ...args) {
  // if (APP_ENV === "production") {
  //   return;
  // }

  if (!import.meta.env.VITEST) {
    const now = new Date().toISOString().slice(0, 19);
    const content = `[${now}]: ${message}`;

    switch (severity) {
      case LOG_SEVERITY.INFO:
        console.log(content, ...args);
        break;
      case LOG_SEVERITY.ERROR:
        console.error(content, ...args);
        break;
      case LOG_SEVERITY.WARNING:
        console.warn(content, ...args);
        break;
      default:
        console.log(content, ...args);
      }
  }
}
